export default "__VITE_ASSET__BviTJrC$__"